import React, { useEffect } from "react"
import { graphql } from "gatsby"
import Hero from "../../components/Hero"
import Header from "../../components/Header"
import WhoweAre from "../../components/WhoweAre"
import OurProduct from "../../components/OurProduct"
import Team from "../../components/Team"
import Seo from "../../components/Seo"
import "../../node_modules/bootstrap/scss/bootstrap.scss"
import "../sass/main.scss"

export default function Home({ data }) {
  useEffect(() => {
    window.prismic = {
      endpoint: "https://dalti.cdn.prismic.io/api/v2",
    }
    // Define selector for selecting
    // anchor links with the hash
    let anchorSelector = 'a[href^="#"]'

    // Collect all such anchor links
    let anchorList = document.querySelectorAll(anchorSelector)

    // Iterate through each of the links
    anchorList.forEach(link => {
      link.onclick = function (e) {
        // Prevent scrolling if the
        // hash value is blank
        e.preventDefault()

        // Get the destination to scroll to
        // using the hash property
        let destination = document.querySelector(this.hash)

        // Scroll to the destination using
        // scrollIntoView method
        destination.scrollIntoView({
          behavior: "smooth",
        })
      }
    })
  }, [])
  return (
    <React.Fragment>
      <Seo />
      <div className="container">
        <Hero data={data} />
        <Header />
        <WhoweAre data={data} />
        <OurProduct data={data} />
        <Team data={data} />
      </div>
    </React.Fragment>
  )
}
export const query = graphql`
  query MyQuery {
    allPrismicMainPage {
      edges {
        node {
          data {
            hero_image {
              alt
              url
            }
            qui_somme_nous_title {
              text
            }
            qui_somme_nous_description {
              html
            }
            nos_produit_heading {
              text
            }
            nos_produit_content {
              html
            }
            notre_equipe_heading {
              text
            }
          }
        }
      }
    }
    allPrismicMainPageBodyTeam {
      nodes {
        items {
          first_and_lastname {
            text
          }
          member_bg {
            text
          }
          portrait {
            alt
            url
          }
          position {
            text
          }
        }
      }
    }
  }
`
